'use client';

import { RatingWidgetComponent } from './RatingWidgetComponent';

export function RatingWidgetComponentC(
  props: React.ComponentProps<typeof RatingWidgetComponent>,
) {
  return <RatingWidgetComponent {...props} />;
}
